<div [class]="{'featured-page-wrapper': true, 'alternative-background': alternativeBackground()}">
    <div class="featured-page">
        <div [class]="{'text-container': true, 'with-image': !!pageImage()}">
            @if(headline()) {
            <app-base-text class="featured-page-headline" [text]="this.headline()" [big]="true" [bold]="true"
                [headline]="true" [gotham]="true" [align]="'center'" [htmlTag]="'h3'"></app-base-text>
            }

            <app-markdown-text class="featured-page-text" [data]="text()" [noModule]="true">
            </app-markdown-text>

            <div class="featured-page-button">
                <a matButton="elevated" [routerLink]="pageLink()">
                    {{ this.linkText() ? this.linkText() : 'Mehr erfahren' }}
                </a>
            </div>
        </div>

        @if (pageImage()) {
        <div class="image-container">
            <img class="mobile" [ngSrc]="pageImageUrl()" [width]="250" [height]="150"
                [loaderParams]="{width: 250, height: 150, fillWithFaceFocus: true}" sizes="100vw"
                [title]="pageImageTitle()" [alt]="pageImageTitle()">
            <img class="tablet" [ngSrc]="pageImageUrl()" [width]="500" [height]="200"
                [loaderParams]="{width: 500, height: 200, fillWithFaceFocus: true}" sizes="90vw"
                [title]="pageImageTitle()" [alt]="pageImageTitle()">
            <img class="desktop" [ngSrc]="pageImageUrl()" [width]="300" [height]="500"
                [loaderParams]="{width: 300, height: 500, fillWithFaceFocus: true}" [sizes]="'20vw'"
                [title]="pageImageTitle()" [alt]="pageImageTitle()">
        </div>
        }
    </div>
</div>